(function () {
    'use strict';

    angular
        .module('app.login')
        .factory('emailConfirmationModal', emailConfirmationModal);

    emailConfirmationModal.$inject = ['$q', '$uibModal', 'Member'];
    function emailConfirmationModal($q, $uibModal, Member) {
        return function emailConfirmationModal(user) {
            return $uibModal.open({
                component: 'sc3EmailConfirmationModal',
                keyboard: false,
                backdrop: 'static',
                resolve: { data: getData } 
            });

            function getData() {
                return user ? { individualId: user.id, email: user.email } : $q.reject('user is null');
            }
        }
    }
})();